import { userHasSinglePermission } from 'util/PermissionsUtils';
import { Permission } from 'common/models/Permissions';

export const AllowTemplates = () => userHasSinglePermission(Permission.TemplatesAdministrator);
